<template>
  <div class="card" v-show="currentCardId == 'pr-message'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自己PR</h2>
        <p>
          書類審査、合格のカギは志望動機と自己PRの表現力！
          AIを使って表現力アップ！
        </p>
        <div class="add-item">
          <el-button
            v-if="inAppPayments"
            id="prime-reasonai-btn"
            type="danger"
            @click="showAiMyprDialog"
            >AIで文章作成</el-button
          >
          <el-button type="success" @click="exampleVisible = true"
            >例文から追加</el-button
          >
        </div>
      </div>
      <div class="card-content">
        <NewRirekishoExampleSentenceDialog
          :value="exampleVisible"
          name="pr-dialog"
          :items="prExamples"
          show-overwrite-warning
          @input="exampleVisible = $event"
          @select="onSelectExample"
        />
        <AiMyprDialog
          :visible="aiMyprVisible"
          @update:visible="onMyprVisible"
          @before-close="cancelAIStream"
        >
          <div class="v--modal-close-top">
            <el-button
              icon="el-icon-circle-close"
              style="font-size: 2rem; padding: 0"
              type="text"
              @click="closeDialog"
            />
          </div>
          <AiMyprDialogHeader
            catch-text="ヤギプライム限定"
            title="自分らしい文章にしよう"
            lead="あなたにまつわる4つの質問で、より自分らしい文章を作成することができます。"
          />
          <div v-if="!aiResultView">
            <AiMyprPrQuestionsForm
              show-digram-toggle
              :use-digram="useDigram"
              @update:use-digram="useDigram = $event"
              :good="formatData.ai_mypr_good || ''"
              @update:good="formatData.ai_mypr_good = $event"
              :bad="formatData.ai_mypr_bad || ''"
              @update:bad="formatData.ai_mypr_bad = $event"
              :hobby="formatData.ai_mypr_hobby || ''"
              @update:hobby="formatData.ai_mypr_hobby = $event"
              :wanted="formatData.ai_mypr_wanted || ''"
              @update:wanted="formatData.ai_mypr_wanted = $event"
              :appeal="formatData.ai_mypr_appeal || ''"
              @update:appeal="formatData.ai_mypr_appeal = $event"
            />
            <div class="mypr-popup-btnarea" v-if="inAppPayments">
              <p class="count-txt">
                <span
                  >利用回数：{{ aiUsageCount }} / {{ aiMaxUsageCount }}回</span
                >
              </p>
              <p class="mypr-attention">
                ※例文選択・AI再生成をすると、現在入力中の文章は<br />上書きされますのでご注意ください。
              </p>
              <div class="prime-cv-block" v-show="!aiIsStreaming">
                <el-button @click="getAIMypr"
                  >この内容でAI自己PRを作成</el-button
                >
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-if="aiIsThinking"
              class="ai-thinking"
              @click="toggleAiReasoning"
            >
              <span class="ai-thinking__icon"></span>
              <span class="ai-thinking__label">{{ aiThinkingLabel }}</span>
              <span class="ai-thinking__dots">
                <span class="ai-thinking__dot"></span>
                <span class="ai-thinking__dot"></span>
                <span class="ai-thinking__dot"></span>
              </span>
            </div>
            <div
              v-if="aiReasoningText"
              class="ai-reasoning"
              :class="
                aiShowReasoning
                  ? 'ai-reasoning--expanded'
                  : 'ai-reasoning--collapsed'
              "
            >
              <div class="ai-reasoning__content">{{ aiReasoningText }}</div>
            </div>
            <div
              v-if="!aiIsThinking && aiReasoningText"
              class="ai-reasoning__toggle"
              @click="toggleAiReasoning"
            >
              <span
                class="ai-reasoning__arrow"
                :class="{ 'ai-reasoning__arrow--open': aiShowReasoning }"
                >▶</span
              >
              {{ aiShowReasoning ? '思考過程を隠す' : '思考過程を見る' }}
            </div>
            <ul class="example-sentence">
              <li @click="applyMyprResult">
                <div class="title">AIからの提案</div>
                <div class="body">
                  <span v-html="aiResultMyprResult"></span
                  ><span
                    v-if="aiIsStreaming && !aiIsThinking"
                    class="ai-cursor"
                  ></span>
                </div>
              </li>
            </ul>
            <div
              v-if="!isYagiPrime"
              class="text-right"
              style="margin-top: 10px"
              v-show="!aiIsStreaming"
            >
              ＼全文を表示する場合は／<br />
              <el-button
                v-if="inAppPayments"
                id="prime-reasonai-register-btn"
                style="
                  color: #fff;
                  background-color: #e3165c;
                  border-color: #e3165c;
                "
                @click="goYagiprimeRegister"
                >ヤギプライム会員になる</el-button
              >
            </div>
          </div>
          <div
            class="text-right"
            style="margin-top: 20px"
            v-show="!aiIsStreaming"
          >
            <el-button
              v-if="isYagiPrime && aiResultView"
              type="primary"
              @click="aiResultView = false"
              >もう一度作る</el-button
            >
            <el-button @click="closeDialog">閉じる</el-button>
          </div>
        </AiMyprDialog>
        <el-input
          type="textarea"
          v-model="formatData.prMessage"
          v-proofread
          :autosize="{ minRows: 6, maxRows: 15 }"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import AiMyprDialog from '@/components/format-edit/AiMyprDialog.vue'
import AiMyprDialogHeader from '@/components/format-edit/AiMyprDialogHeader.vue'
import AiMyprPrQuestionsForm from '@/components/format-edit/AiMyprPrQuestionsForm.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import {
  useShokurekishoFormatData,
  toExampleDialogItems,
  type ShokurekishoExampleSentences
} from '@/composables/format-edit/useShokurekishoFormatData'
import { useShokurekishoAiMypr } from '@/composables/format-edit/useShokurekishoAiMypr'
import '@/assets/css/ai-streaming.css'

const props = defineProps<{
  currentCardId?: string
  exampleSentences?: ShokurekishoExampleSentences
}>()

const formatData = useShokurekishoFormatData()
const { globalVar } = useHostServices()
const exampleVisible = ref(false)

const inAppPayments = computed(
  () =>
    !!(globalVar as typeof globalVar & { in_app_payments?: boolean })
      .in_app_payments
)
const isYagiPrime = computed(() => !!globalVar.isYagiPrime)

const prExamples = computed(() =>
  toExampleDialogItems(
    props.exampleSentences?.prMessage,
    formatData.occupation || 'others'
  )
)

const {
  aiMyprVisible,
  useDigram,
  aiResultView,
  aiResultMyprResult,
  aiUsageCount,
  aiMaxUsageCount,
  aiIsStreaming,
  aiIsThinking,
  aiThinkingLabel,
  aiReasoningText,
  aiShowReasoning,
  showAiMyprDialog,
  closeDialog,
  getAIMypr,
  goYagiprimeRegister,
  applyMyprResult,
  toggleAiReasoning,
  cancelAIStream
} = useShokurekishoAiMypr(formatData)

function onSelectExample(item: { description: string }) {
  formatData.prMessage = item.description.replace(/<br>/gi, '\n')
}

function onMyprVisible(value: boolean) {
  aiMyprVisible.value = value
  if (!value) cancelAIStream()
}
</script>

<style lang="scss" scoped>
.el-button--danger {
  position: relative;
  background-color: #ff8c00;
  border-color: #ff8c00;

  &::after {
    position: absolute;
    content: '✨';
    font-size: 20px;
    top: -5px;
    right: -7px;
  }
}
</style>
